"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("../styles");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HeaderText = function HeaderText(_ref) {
  var headerAlignment = _ref.headerAlignment,
      subtitle = _ref.subtitle,
      title = _ref.title,
      titleSize = _ref.titleSize,
      subtitleSize = _ref.subtitleSize,
      isInlineTitle = _ref.isInlineTitle;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.TitleTextContainer, {
    shouldCenterText: headerAlignment === _designLanguage.Text.TextAlignments.Center,
    isInlineTitle: isInlineTitle
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    tag: "h2",
    styles: _designLanguage.Text.Styles.NavBarExpandedTitle,
    size: titleSize || (0, _lodash["default"])(theme, 'Modal.titleSize')
  }, title)), subtitle && subtitle.length && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    color: _designLanguage.Text.Colors.TextTertiary,
    size: subtitleSize,
    styles: _designLanguage.Text.Styles.NavBarExpandedSubtitle,
    textAlign: headerAlignment
  }, subtitle));
};

HeaderText.propTypes = {
  headerAlignment: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  title: _propTypes["default"].node,
  titleSize: _propTypes["default"].number,
  subtitleSize: _propTypes["default"].number,
  isInlineTitle: _propTypes["default"].bool
};
var _default = HeaderText;
exports["default"] = _default;